// TODO: Bring back when old initiative routes are fully deprecated
// PR #708
// import appConstants from './apps'

import { dynamicOrganizationDomains } from '.'

export const isDynamicOrganizationDomain =
   dynamicOrganizationDomains.includes(window.location.hostname)

// Global
export const appUrl = app => `/apps/${app.type}`

// Admin Workspace
export const adminUrl = '/admin'
export const adminAppUrl = app => `${adminUrl}/apps/${app.id}`
export const adminCustomPageUrl = page => `${adminUrl}/pages/custom/${page.id}`
export const adminExploreEditUrl = `${adminUrl}/pages/explore`
export const adminHomeEditUrl = `${adminUrl}/pages/home`
export const adminManagePagesUrl = `${adminUrl}/manage-pages`
export const adminPeopleUrl = `${adminUrl}/people`
export const adminPeopleRoleUrl = role => `${adminUrl}/people/${role.id}`
export const adminReportsUrl = `${adminUrl}/advanced/reports`

// Organization Settings
export const settingsUrl = '/settings'
export const settingsAccountUrl = `${settingsUrl}/account`
export const settingsBrandUrl = `${settingsUrl}/brand`
export const settingsContentUrl = `${settingsUrl}/content`
export const settingsContentPagesUrl = `${settingsUrl}/content/pages`
export const settingsDesignUrl = `${settingsUrl}/design`
export const settingsPeopleUrl = `${settingsUrl}/people`
export const settingsPeopleRoleUrl = `${settingsUrl}/people/role`
export const settingsSiteUrl = `${settingsUrl}/site`
export const settingsSiteCommerceUrl = `${settingsUrl}/site/commerce`
export const settingsSiteReportsUrl = `${settingsUrl}/site/reports`
export const settingsContentInitiativeTypeUrl = initiativeTypeId => (
   `${settingsUrl}/content/initiativeType/${initiativeTypeId}`
)

// TODO: Bring back when old initiative routes are fully deprecated
// PR #708
// Initiative
// export const initiativeUrl = (initiative) => {
//    // TODO: This won't be necessary when app data comes with initiative
//    // PR # 672
//    const app = appConstants.find(a => a.initiativeClass === initiative.class)
//    return `/apps/${app.type}/${initiative.slug}`
// }

export const initiativeUrl = initiative => `/initiatives/${initiative.slug}`
export const initiativeJoinUrl = initiative => `${initiativeUrl(initiative)}/join`
export const initiativeSettingsUrl = initiative => `${initiativeUrl(initiative)}/settings`

export const initiativeSettingsContentUrl = initiative => (
   `${initiativeSettingsUrl(initiative)}/content`
)

export const initiativeSettingsPeopleUrl = (initiative, roleId) => (roleId
   ? `${initiativeSettingsUrl(initiative)}/people/role/${roleId}`
   : `${initiativeSettingsUrl(initiative)}/people`)

export const initiativeSettingsReportsUrl = initiative => (
   `${initiativeSettingsUrl(initiative)}/reports`
)

// Page
export const pageUrl = page => `/pages/${page.slug}`
